module.exports = __webpack_public_path__ + "img/cv-btn.6bcd70ba.png";